import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { finalize } from 'rxjs/operators';

import { PageTitleService } from '@tablesready/common-ui';
import { ResendVerificationService } from './services';
import { APP_VARIABLES_TOKEN, AppVariables } from '@tablesready/frontend-variables';

@Component({
  selector: 'tablesready-verification',
  styleUrls: ['./verification.component.scss'],
  templateUrl: './verification.component.html',
})
export class VerificationComponent implements OnInit {
  sending = false;
  accountId: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly pageTitleService: PageTitleService,
    private readonly resendVerificationService: ResendVerificationService,
    @Inject(APP_VARIABLES_TOKEN) public readonly appVariables: AppVariables,
  ) {
    this.accountId = this.route.snapshot.queryParamMap.get('username');
  }

  ngOnInit(): void {
    this.pageTitleService.setTitle('Verify Your Account');
  }

  resend() {
    if (this.sending) {
      return;
    }

    this.sending = true;

    this.resendVerificationService.resend(this.accountId)
      .pipe(finalize(() => this.sending = false))
      .subscribe();
  }
}
